export default __webpack_public_path__ + "273a4a485c38962e4fe1c1c0b94b489b96fbee343c1b341511de4f66b6637598.png";